module.exports = __webpack_public_path__ + "assets/media/pause_play_icon.faf4c79b.svg";